module.exports = __webpack_public_path__ + "static/img/img-4.53a936f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-4.png
// module id = s99P
// module chunks = 1